import { put, debounce, select } from 'redux-saga/effects'; // , takeEvery
import * as filtersActions from '../actions/filtersActions';
import * as customersActions from '../actions/customers';

function* updateFilterFieldsSaga() {
  const filters = yield select(state => state.Customers.filters);
  let countFilters = 0;
  if (filters.search && filters.search.length > 1) {
    countFilters++;
  }
  if (filters.fields) {
    countFilters += Object.keys(filters.fields).length;
  }
  if (filters.count !== countFilters) {
    yield put(filtersActions.countFiltersCustomers(countFilters));
  }
  if (countFilters > 0) {
    yield put(customersActions.getFilterCustomers(filters));
  } else {
    yield put(customersActions.getAllCustomers());
  }
}

export function* filtersConfigWatcher() {
  yield debounce(
    600,
    [
      filtersActions.updateFilterFieldsCustomers.toString(),
      filtersActions.searchCustomers.toString(),
    ],
    updateFilterFieldsSaga
  );
}
